// eslint-disable-next-line import/prefer-default-export
export const ERROR_PAGE_TEXT = {
  TITLE: 'We\'re sorry.',
  SPANNED_TITLE: 'Something went wrong.',
  SUB_TITLE: 'Please try again later. If the problem persists, please contact your system administrator.',
  BUTTON: 'Return to Learner Credit Plans',
};
